type WwwLocation = {
  initHref: string;
};

type WwwLocationAccessors = {
  getInitParam: (paramName: string) => string | null;
  hasInitParam: (paramName: string) => boolean;
  getAllInitParam: (paramName: string) => string[];
  getInitParamsArray: () => { key: string; value: string }[];
};

const createAccessors = ({ url }: { url: URL | null }): WwwLocationAccessors => {
  return {
    getInitParam: (paramName) => url?.searchParams.get(paramName) ?? null,
    hasInitParam: (paramName) => url?.searchParams.has(paramName) ?? false,
    getAllInitParam: (paramName) => url?.searchParams.getAll(paramName) ?? [],
    getInitParamsArray: () =>
      url ? Array.from(url.searchParams.entries()).map(([key, value]) => ({ key, value })) : [],
  };
};

const getFallbackHref = (): string => {
  const navEntryName = performance.getEntriesByType?.('navigation')[0]?.name;
  if (navEntryName) {
    console.warn('useWwwLocation: not initialized, using navigation entry');
    return navEntryName;
  }
  console.error('useWwwLocation: not initialized, using window.location');
  return window.location.href;
};

/** Get information about the url used to load the page */
export function useWwwLocation(): WwwLocationAccessors {
  if (import.meta.server) {
    return createAccessors({ url: null });
  }

  const initHref =
    (window as unknown as { wwwLocation?: WwwLocation }).wwwLocation?.initHref || getFallbackHref();
  return createAccessors({ url: new URL(initHref) });
}
